import React, {useEffect, useState} from 'react';
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import _ from 'lodash';
import {useLazyQuery} from '@apollo/client';
import { useToasts } from "react-toast-notifications";
import { GET_SUMMARY_STOCK } from '../../graphql/totalSummary/query';

const SummaryStock = ({systems, pages, date, setIsLoading}) => {
    const { addToast } = useToasts();
    const [tableData, setTableData] = useState([]);
    const [summarySearch, setSummarySearch] = useState([]);
    const [topSale, setTopSale] = useState([]);
    const [goodBalance, setGoodBalance] = useState([]);
    //* Query ***
    const [getSummaryStock, { data: summaryStockData, loading: loadingSummaryStock }] = useLazyQuery(GET_SUMMARY_STOCK, {
        fetchPolicy: 'cache-and-network',
    });

    //* useEffect ***
    useEffect(() => {
        if(!_.isEmpty(systems?.amount)|| !_.isEmpty(pages?.amount) || !_.isEmpty(date.createdAt_lt)) {
            setTimeout(() => {
                handleSummaryStock();
            }, 1000);
        }
    }, [systems, pages, date]);

    useEffect(() => {
        if(!_.isEmpty(summaryStockData)) {
            const summaryStock = summaryStockData?.getSummaryStock;
            const newSummaryStock = JSON.parse(summaryStock);
            if(newSummaryStock[0].length > 0) {
                setTableData(newSummaryStock[0]);
            }
            if(newSummaryStock[1].length > 0) {
                setSummarySearch(newSummaryStock[1]);
            }if(newSummaryStock[2].length > 0){
                setTopSale(newSummaryStock[2]);
            }
            if(newSummaryStock[3].length > 0) {
                setGoodBalance(newSummaryStock[3]);
            }
        }
    }, [summaryStockData]);

    useEffect(() => {
        if(loadingSummaryStock) setIsLoading((prev) => ({...prev, loadingSummaryStock: true}));
    }, [loadingSummaryStock]);

    //* Function ****
    const handleSummaryStock = async () => {
        if (loadingSummaryStock) return;
        try {
            let where = {}
            if(!_.isEmpty(systems?.listName)) where = {...where, systems: systems?.listName.split(', ')};
            if(!_.isEmpty(pages?.listId)) where = {...where, pages: pages?.listId.split(', ')};
            if(!_.isEmpty(date?.createdAt_gte) && !_.isEmpty(date?.createdAt_lt)) {
                where = {...where, 
                    createdAt_gte: date?.createdAt_gte,
                    createdAt_lt: date?.createdAt_lt
                };
            }

            handleCloseState();
            await getSummaryStock({variables: { where }});
            setIsLoading((prev) => ({...prev, loadingSummaryStock: false}));
        } catch (error) {
            handleCloseState();
            setIsLoading((prev) => ({...prev, loadingSummaryStock: false}));
            console.log("handleSummaryStock error: ", error);
            if (error.message){
                console.log("1 handleSummaryStock error: ", error.message);
                addToast("ບໍ່ພົບຂໍມູນ", {
                    appearance: "warning",
                    autoDismiss: true,
                });
            } else{
                console.log("2 handleSummaryStock error: ", error.message);
                addToast("ມີຂໍຜີດຜາດທີ່ບໍ່ຄາດຄີດສຳລັບ ຍອດເງີນ", {
                    appearance: "error",
                    autoDismiss: true,
                });
            }
        }
    };
    const handleCloseState = () => {
        setTableData([]);
        setSummarySearch([]);
        setTopSale([]);
        setGoodBalance([]);
    }
    // const topProducts = [
    //     { product: 'Shirt', category: 'Clothes', date: '01/12/2024 - 31/12/2024', amount: 100, currency: "ກີບ", priceOrigin: '5,000', totalPriceOrigin: '5,000', priceSale: '10,000', totalPriceSale: '1,000,000', exChangeRate: '1', totalPriceOriginKip: '5,000', totalPriceSaleKip: '1,000,000' },
    //     { product: 'Shirt A', category: 'Clothes', date: '01/12/2024 - 31/12/2024', amount: 90, currency: "ກີບ", priceOrigin: '10,222', totalPriceOrigin: '5,000', priceSale: '22,222', totalPriceSale: '2,000,000', exChangeRate: '1', totalPriceOriginKip: '5,000', totalPriceSaleKip: '1,000,000' },
    //     { product: 'Shirt B', category: 'Clothes', date: '01/12/2024 - 31/12/2024', amount: 80, currency: "ກີບ", priceOrigin: '20,500', totalPriceOrigin: '5,000', priceSale: '37,500', totalPriceSale: '3,000,000', exChangeRate: '1', totalPriceOriginKip: '5,000', totalPriceSaleKip: '1,000,000' },
    //     { product: 'Shirt C', category: 'Clothes', date: '01/12/2024 - 31/12/2024', amount: 70, currency: "ກີບ", priceOrigin: '40,142', totalPriceOrigin: '5,000', priceSale: '57,142', totalPriceSale: '4,000,000', exChangeRate: '1', totalPriceOriginKip: '5,000', totalPriceSaleKip: '1,000,000' },
    //     { product: 'Shirt D', category: 'Clothes', date: '01/12/2024 - 31/12/2024', amount: 60, currency: "ກີບ", priceOrigin: '63,333', totalPriceOrigin: '5,000', priceSale: '83,333', totalPriceSale: '5,000,000', exChangeRate: '1', totalPriceOriginKip: '5,000', totalPriceSaleKip: '1,000,000' },
    // ];

    return (
        <>
            <Table responsive bordered hover className="mb-4"> {/* //! summary search stock */}
                    <thead className="bg-light">
                    <tr>
                        <th colSpan="8" className="text-center">ຍອດສີນຄ້າຈາກການຄົ້ນຫາ</th>
                    </tr>
                    <tr>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}></th>
                        <th style={{ color: '#0d6efd', minWidth: '100px' }}>ຈຳນວນສີນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ບາດ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ບາດ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ໂດລາ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ໂດລາ)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {_.isEmpty(summarySearch)? (
                        <tr>
                            <td colSpan={8} className='text-center'>
                                {loadingSummaryStock ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                            </td>
                        </tr>
                    ) : (
                        summarySearch.map((row, index) => (
                            <tr key={index}>
                            <td style={{ color: '#0d6efd' }}>{row?.label}</td>
                            <td>{row?.amount.toLocaleString('en-US')}</td>
                            <td>{row?.targetKip.toLocaleString('en-US')}</td>
                            <td>{row?.saleKip.toLocaleString('en-US')}</td>
                            <td>{row?.targetBaht.toLocaleString('en-US')}</td>
                            <td>{row?.saleBaht.toLocaleString('en-US')}</td> 
                            <td>{row?.targetUsd.toLocaleString('en-US')}</td>
                            <td>{row?.saleUsd.toLocaleString('en-US')}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
            </Table>

            <Table responsive bordered hover className="mb-4"> {/* //! summary all stock */}
                    <thead className="bg-light">
                    <tr>
                        <th colSpan="8" className="text-center">ຍອດສີນຄ້າທັງຫມົດ</th>
                    </tr>
                    <tr>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}></th>
                        <th style={{ color: '#0d6efd', minWidth: '100px' }}>ຈຳນວນສີນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ບາດ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ບາດ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຕົ້ນ(ໂດລາ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '150px' }}>ເງີນຂາຍ(ໂດລາ)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {_.isEmpty(tableData)? (
                        <tr>
                            <td colSpan={8} className='text-center'>
                                {loadingSummaryStock ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                            </td>
                        </tr>
                    ) : (
                        tableData.map((row, index) => (
                            <tr key={index}>
                            <td style={{ color: '#0d6efd' }}>{row?.label}</td>
                            <td>{row?.amount.toLocaleString('en-US')}</td>
                            <td>{row?.targetKip.toLocaleString('en-US')}</td>
                            <td>{row?.saleKip.toLocaleString('en-US')}</td>
                            <td>{row?.targetBaht.toLocaleString('en-US')}</td>
                            <td>{row?.saleBaht.toLocaleString('en-US')}</td> 
                            <td>{row?.targetUsd.toLocaleString('en-US')}</td>
                            <td>{row?.saleUsd.toLocaleString('en-US')}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
            </Table>

            {/* Top sale product */}
            <Table responsive bordered hover className="mb-4 text-wrap">
                <thead className="bg-light">
                    <tr>
                        <th colSpan='13' className="text-center">ສິນຄ້າຂາຍດີ(10ອັນດັບ)</th>
                    </tr>
                    <tr>
                        <th style={{ color: '#0d6efd' }}>No.</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ຊື່ສິນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px'}}>ປະເພດສີນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ວັນທີ</th>
                        <th style={{ color: '#0d6efd', minWidth: '60px' }}>ຈຳນວນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '60px' }}>ສະກຸນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '80px' }}>ລາຄາຕົ້ນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ລວມເງີນຕົ້ນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '90px' }}>ລາຄາຂາຍ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ລວມເງີນຂາຍ</th>
                        <th style={{ color: '#0d6efd', minWidth: '50px' }}>ແລກປ່ຽນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '130px' }}>ລວມເງີນຕົ້ນ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '130px' }}>ລວມເງີນຂາຍ(ກີບ)</th>
                    </tr>
                </thead>
                <tbody>
                    {_.isEmpty(topSale)? (
                            <tr>
                                <td colSpan={13} className='text-center'>
                                    {loadingSummaryStock ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                                </td>
                            </tr>
                        ) : (
                        topSale.map((row, index) => (
                            <tr key={index}>
                                <td style={{ color: '#0d6efd' }}>{index+1}</td>
                                <td>{row?.product}</td>
                                <td>{row?.category}</td>
                                <td>{row?.date}</td>
                                <td>{row?.amount.toLocaleString('en-US')}</td>
                                <td>{row?.currency}</td>
                                <td>{row?.priceOrigin.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceOrigin.toLocaleString('en-US')}</td>
                                <td>{row?.priceSale.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceSale.toLocaleString('en-US')}</td>
                                <td>{row?.exChangeRate.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceOriginKip.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceSaleKip.toLocaleString('en-US')}</td>
                            </tr>
                        )))
                    }
                </tbody>
            </Table>

            {/* Top product high money */}
            <Table responsive bordered hover className="mb-4 text-wrap">
                <thead className="bg-light">
                    <tr>
                        <th colSpan='13' className="text-center">ສິນຄ້າສ້າງຍອດເງີນໄດ້ດີ(10ອັນດັບ)</th>
                    </tr>
                    <tr>
                        <th style={{ color: '#0d6efd' }}>No.</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ຊື່ສິນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px'}}>ປະເພດສີນຄ້າ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ວັນທີ</th>
                        <th style={{ color: '#0d6efd', minWidth: '60px' }}>ຈຳນວນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '60px' }}>ສະກຸນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '80px' }}>ລາຄາຕົ້ນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ລວມເງີນຕົ້ນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '90px' }}>ລາຄາຂາຍ</th>
                        <th style={{ color: '#0d6efd', minWidth: '120px' }}>ລວມເງີນຂາຍ</th>
                        <th style={{ color: '#0d6efd', minWidth: '50px' }}>ແລກປ່ຽນ</th>
                        <th style={{ color: '#0d6efd', minWidth: '130px' }}>ລວມເງີນຕົ້ນ(ກີບ)</th>
                        <th style={{ color: '#0d6efd', minWidth: '130px' }}>ລວມເງີນຂາຍ(ກີບ)</th>
                    </tr>
                </thead>
                <tbody>
                {_.isEmpty(goodBalance)? (
                            <tr>
                                <td colSpan={13} className='text-center'>
                                    {loadingSummaryStock ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                                </td>
                            </tr>
                        ) : (
                            goodBalance.map((row, index) => (
                            <tr key={index}>
                                <td style={{ color: '#0d6efd' }}>{index+1}</td>
                                <td>{row?.product}</td>
                                <td>{row?.category}</td>
                                <td>{row?.date}</td>
                                <td>{row?.amount.toLocaleString('en-US')}</td>
                                <td>{row?.currency}</td>
                                <td>{row?.priceOrigin.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceOrigin.toLocaleString('en-US')}</td>
                                <td>{row?.priceSale.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceSale.toLocaleString('en-US')}</td>
                                <td>{row?.exChangeRate.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceOriginKip.toLocaleString('en-US')}</td>
                                <td>{row?.totalPriceSaleKip.toLocaleString('en-US')}</td>
                            </tr>
                    ))
                )}
                </tbody>
            </Table>
        </>
    );
};
export default SummaryStock
